<template>
  <div class="message-center">
    <!-- 头部 -->
    <div class="message-header">
      <h1 class="title">{{ $t('_xx._bt') }}</h1>
      <div class="header-actions">
        <!-- <button class="msg-action-btn" :class="{ active: filterType === 'all' }" @click="filterType = 'all'">
                    全部消息
                </button>
                <button class="msg-action-btn" :class="{ active: filterType === 'unread' }" @click="filterType = 'unread'">
                    未读消息
                </button>
                <button class="msg-action-btn" @click="markAllAsRead">
                    <i class="fas fa-check-double"></i>
                    全部已读
                </button>
                <button class="msg-action-btn delete-btn" @click="clearAllMessages">
                    <i class="fas fa-trash"></i>
                    清空消息
                </button> -->
      </div>
    </div>

    <!-- 消息列表 -->
    <div class="message-list" v-if="filteredMessages.length > 0">
      <div v-for="message in filteredMessages" :key="message.id" :class="['message-item', { unread: message.is_read == 1 }]" @click="toggleMessage(message)">
        <div class="message-avatar">
          <i :class="message.icon"></i>
        </div>
        <div class="message-content">
          <div class="message-title">
            <span class="title-text">{{ message.title }}</span>
            <span class="message-time">{{ formatTime(message.create_time) }}</span>
          </div>
          <div style="display: flex; align-items: baseline">
            <div class="message-preview" v-html="message.content" style="height: 23px; overflow: hidden"></div>
            <div style="color: #2196f3; font-size: 13px; margin-left: 10px">[{{ $t('_xx._djckgd') }}]</div>
          </div>
          <div class="message-detail" v-if="message.expanded">
            <div class="detail-content" v-html="message.content"></div>
            <div class="message-actions">
              <!-- <button v-if="!message.read" class="read-btn" @click.stop="markAsRead(message)">标记已读</button> -->
              <!-- <button class="delete-single-btn" @click.stop="deleteMessage(message.id)">删除</button> -->
            </div>
          </div>
        </div>
        <div class="message-status">
          <i v-if="message.is_read == 1" class="unread-dot"></i>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div class="empty-state" v-else>
      <div class="empty-icon">
        <i class="fas fa-envelope-open"></i>
      </div>
      <h3 class="empty-title">{{ $t('_xx._wjl') }}</h3>
      <p class="empty-desc">{{ $t('_xx._zsmyxx') }}</p>
      <!-- <button class="refresh-btn" @click="refreshMessages">
        <i class="fas fa-redo"></i>
        {{ $t('_xx._sxxx') }}
      </button> -->
    </div>

    <!-- 加载状态 -->
    <div class="loading-state" v-if="loading">
      <i class="fas fa-spinner fa-spin"></i>
      <span>{{ $t('_a._jzz') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageCenter',
  data() {
    return {
      loading: false,
      filterType: 'all',
      messages: [
        // {
        //     id: 1,
        //     title: '系统通知',
        //     content: '您的账户已成功升级为VIP会员，享受更多特权',
        //     detail: '尊敬的会员，您的账户已成功升级为VIP会员。现在您可以享受：无广告体验、专属内容、优先客服等特权。感谢您的支持！',
        //     time: new Date('2024-01-15 10:30:00'),
        //     type: 'system',
        //     icon: 'fas fa-cog',
        //     read: true,
        //     expanded: true
        // },
      ]
    }
  },
  created() {
    this.getList()
  },
  computed: {
    filteredMessages() {
      if (this.filterType === 'unread') {
        return this.messages.filter((message) => !message.read)
      }
      return this.messages
    },
    unreadCount() {
      return this.messages.filter((message) => !message.read).length
    }
  },
  methods: {
    getList() {
      let that = this
      this.$api.userMessage.getList().then((res) => {
        that.messages = res.data
      })
    },
    toggleMessage(message) {
      message.expanded = !message.expanded
      // 点击消息时自动标记为已读
      // if (!message.read) {
      //   this.markAsRead(message)
      // }
    },

    markAsRead(message) {
      message.read = true
      this.$message.success('标记为已读')
    },

    markAllAsRead() {
      this.messages.forEach((message) => {
        message.read = true
      })
      this.$message.success('全部标记为已读')
    },

    deleteMessage(id) {
      this.messages = this.messages.filter((message) => message.id !== id)
      this.$message.success('删除成功')
    },

    clearAllMessages() {
      if (this.messages.length === 0) {
        this.$message.info('没有可清空的消息')
        return
      }

      this.$confirm('确定要清空所有消息吗？', '提示', {
        okText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        ok: () => {
          this.messages = []
          this.$message.success('已清空所有消息')
        }
      })
    },

    refreshMessages() {
      this.loading = true
      // 模拟加载新消息
      setTimeout(() => {
        this.messages = [
          //   {
          //     id: 1,
          //     title: '欢迎回来',
          //     content: '感谢您再次访问我们的平台',
          //     detail: '欢迎回来！我们为您准备了个性化推荐内容，请查看最新更新。如有任何问题，请联系客服。',
          //     time: new Date(),
          //     type: 'system',
          //     icon: 'fas fa-heart',
          //     read: false,
          //     expanded: false
          //   }
        ]
        this.loading = false
        this.$message.success(this.$t('_xx._sxcg'))
      }, 1000)
    },
    formatTime(timeStr) {
      const now = new Date()
      const time = new Date(timeStr)
      const diff = now - time
      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor(diff / (1000 * 60 * 60))
      const minutes = Math.floor(diff / (1000 * 60))

      if (days > 0) return this.$t('_xx._ntq', { n: days })
      if (hours > 0) return this.$t('_xx._nxsq', { n: hours })
      if (minutes > 0) return this.$t('_xx._nfzq', { n: minutes })
      return this.$t('_xx._nggq')
    }
  }
}
</script>

<style scoped>
.message-center {
  max-width: 1200px;
  margin: 0 auto;
  background: #1a1f26;
  border-radius: 12px;
  border: 1px solid #2a3038;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  min-height: 600px;
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #2a3038;
}

.title {
  font-size: 24px;
  font-weight: 600;
  color: #e8edf2;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.msg-action-btn {
  padding: 8px 16px;
  border: 1px solid #2a3038;
  border-radius: 6px;
  background: #0a0d0f;
  color: #8a949f;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.msg-action-btn:hover {
  border-color: #ffb300;
  color: #ffb300;
}

.msg-action-btn.active {
  background: linear-gradient(135deg, #ffb300, #f57c00);
  border-color: #ffb300;
  color: #0b0d0f;
  font-weight: 600;
}

.delete-btn {
  color: #ff4d4f;
}

.delete-btn:hover {
  border-color: #ff4d4f;
  color: #ff4d4f;
}

.message-list {
  padding: 0;
}

.message-item {
  display: flex;
  padding: 20px 24px;
  border-bottom: 1px solid #2a3038;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
}

.message-item:hover {
  background: #14181c;
}

.message-item.unread {
  background: #1a2e1a;
}

.message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffb300, #f57c00);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
}

.message-avatar i {
  color: #0b0d0f;
  font-size: 16px;
}

.message-content {
  flex: 1;
  min-width: 0;
}

.message-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.title-text {
  font-weight: 600;
  color: #e8edf2;
  font-size: 16px;
}

.message-time {
  font-size: 12px;
  color: #4a5662;
}

.message-preview {
  color: #8a949f;
  font-size: 14px;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-detail {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #2a3038;
}

.detail-content {
  color: #8a949f;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 12px;
}

.message-actions {
  display: flex;
  gap: 8px;
}

.read-btn,
.delete-single-btn {
  padding: 4px 12px;
  border: 1px solid #2a3038;
  border-radius: 4px;
  background: #0a0d0f;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.read-btn {
  color: #ffb300;
  border-color: #ffb300;
}

.read-btn:hover {
  background: #ffb300;
  color: #0b0d0f;
}

.delete-single-btn {
  color: #ff4d4f;
  border-color: #ff4d4f;
}

.delete-single-btn:hover {
  background: #ff4d4f;
  color: white;
}

.message-status {
  display: flex;
  align-items: center;
  margin-left: 12px;
}

.unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ff4d4f;
}

.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #4a5662;
}

.empty-icon {
  font-size: 64px;
  color: #2a3038;
  margin-bottom: 24px;
}

.empty-title {
  font-size: 20px;
  color: #8a949f;
  margin-bottom: 12px;
}

.empty-desc {
  color: #4a5662;
  margin-bottom: 24px;
}

.refresh-btn {
  padding: 10px 24px;
  border: 1px solid #ffb300;
  border-radius: 6px;
  background: #0a0d0f;
  color: #ffb300;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.refresh-btn:hover {
  background: #ffb300;
  color: #0b0d0f;
}

.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: #ffb300;
  gap: 8px;
}


/* 响应式设计 */
@media (max-width: 768px) {
  .message-center {
    margin: 10px;
  }

  .message-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .header-actions {
    flex-wrap: wrap;
  }

  .message-item {
    padding: 16px;
  }
}
</style>
